"use client";

import { Box } from "@revoo/design-system/ui/Box/Box";
import { Button } from "@revoo/design-system/ui/Button/Button";
import { Flex } from "@revoo/design-system/ui/Flex/Flex";
import { useTheme } from "@revoo/design-system/providers/ThemeProvider";
import { Icon } from "@revoo/design-system/ui/Icon/Icon";
import { useMediaQuery } from "@chakra-ui/react";
import { Trans } from "react-i18next";
import React from "react";
import Link from "next/link";
import SignupStart from "@/libs/auth/pages/Signup/SignupStart/SignupStart";
import useMatch from "@/libs/shared/hooks/useMatch";
import SignupStartProvider from "@/libs/auth/pages/Signup/SignupStart/SignupStartProvider";

const Signup = ({ children }: { children: React.ReactNode }) => {
  const { images, Logo, device } = useTheme();
  const [isLargerThanMd]: boolean[] = useMediaQuery(device.md, { ssr: false });
  const match = useMatch("/signup");
  const matchComplete = useMatch("/signup/4");

  return (
    <Flex
      h={{
        base: "auto",
        sm: "100vh",
      }}
      mb={{
        base: 8,
        md: 0,
      }}
      w="full"
      alignItems="center"
      justify="center"
      backgroundImage={["none", "none", "none", images.loginBg]}
      backgroundSize="cover"
      bgPosition={"center"}
      zIndex={12}
      direction="column"
    >
      <Box
        display={["none", "none", "none", "block"]}
        position={"absolute"}
        top={0}
        left={0}
        right={0}
        bottom={0}
        backgroundImage={
          "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.103353) 29%, rgba(0, 0, 0, 0.708397) 100%)"
        }
      />
      <Box
        display={["none", "none", "none", "block"]}
        position={"absolute"}
        top={0}
        left={0}
        right={0}
        bottom={0}
        backgroundImage={
          "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.103353) 29%, rgba(0, 0, 0, 0.708397) 100%)"
        }
      />
      <Icon
        h={isLargerThanMd ? 16 : 7}
        w={isLargerThanMd ? 28 : "auto"}
        icon={Logo}
        mb={8}
        position={"absolute"}
        top={12}
        left={["50%", "50%", "50%", 16]}
        transform={[
          "translateX(-50%)",
          "translateX(-50%)",
          "translateX(-50%)",
          "none",
        ]}
      />
      <Flex
        direction="column"
        gap={3.5}
        mt={{
          base: 15,
          md: 0,
        }}
        w="full"
      >
        {match ? (
          <SignupStartProvider>
            <SignupStart />
          </SignupStartProvider>
        ) : (
          children
        )}
        {!matchComplete && (
          <Flex
            h={24}
            minW={["auto", "auto", "auto", "lg"]}
            margin={[12, "0 auto"]}
            bg="palette.secondary.100"
            px={6}
            borderRadius="lg"
            position="relative"
            zIndex={1}
            alignItems="center"
            justifyContent={{
              base: "center",
              md: "space-between",
            }}
            direction={{
              base: "column",
              md: "row",
            }}
            gap={{
              base: 4,
              md: 0,
            }}
          >
            <Trans
              i18nKey={
                match
                  ? "Signup:already_have_account"
                  : "Signup:dont_want_to_register"
              }
            />
            <Link href="/">
              <Button variant="solid">
                <Trans i18nKey="Signup:login" />
              </Button>
            </Link>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default Signup;
